import React, {useCallback} from 'react';
import {Button, Col, Modal, ModalBody, ModalHeader, Row} from "reactstrap5";
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";
import iconStop from "../../../images/modal-icon-stop2.svg";
import Lock from "../../../animation/unlock_key_anim.json";
import Lottie from "react-lottie";

const UsingTrialModal = ({afterClose}) => {

    const clickBuy = useCallback(() => {
        afterClose();
        setTimeout(() => document.getElementById('premium-order').scrollIntoView(), 500);
    }, [afterClose]);

    const lottieOptions = {
        loop: true,
        autoplay: true,
        animationData: Lock,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    return (
        <Modal isOpen={true} toggle={afterClose} fade={true} centered={true} size="lg" contentClassName="rounded-20">
            <ModalHeader tag="div" toggle={afterClose} className="align-items-start">
                <div className="d-flex align-content-center">
                    <Lottie options={lottieOptions} height={50} width={50} />
                    <h1 className="modal-title text-22 text-start my-auto ps-3">
                        <FormattedMessage defaultMessage="Aktivovat zkušební verzi"/><br/>
                        <FormattedMessage defaultMessage="Škola s{nbsp}nadhledem PREMIUM" values={{ nbsp: <React.Fragment>&nbsp;</React.Fragment> }}/>
                    </h1>
                </div>
            </ModalHeader>
            <ModalBody>
                <Row>
                    <Col xs={12} lg={6}>
                        <div className="ps-2">
                            <img src={iconStop} />
                        </div>
                        <p className="mt-3 text-19 ps-2">
                            <FormattedMessage defaultMessage="Bezplatnou zkušební verzi máte již aktivovanou, tuto možnost lze využít pouze jednou."  values={{ cannot: <strong><FormattedMessage defaultMessage="nemůžeme aktivovat" /></strong> }} />
                        </p>
                    </Col>
                    <Col xs={12} lg={6} className="text-center mt-3 mt-lg-0">
                        <h2 className="text-start text-18 ps-2">
                            <FormattedMessage defaultMessage="Ale nebuďte smutní..."/>
                        </h2>
                        <p className="mt-3 text-14 ps-2 mb-4 text-start">
                            <FormattedMessage
                                defaultMessage="Školu s{nbsp}nadhledem PREMIUM si můžete koupit. Roční předplatné pro dvě děti vás vyjde levněji, než kdybyste je vzali do cukrárny." values={{ nbsp: <React.Fragment>&nbsp;</React.Fragment> }}/>
                        </p>
                        <Button color="-blue" className="btn--bolder mb-3" onClick={clickBuy}>
                            <FormattedMessage defaultMessage="Zakoupit předplatné"/>
                        </Button>
                    </Col>
                </Row>
            </ModalBody>
        </Modal>
    );

};

UsingTrialModal.propTypes = {
    afterClose: PropTypes.func.isRequired,
};

UsingTrialModal.defaultProps = {}

export default UsingTrialModal;
